import '@mdi/font/css/materialdesignicons.css';
import { vuetifyOptions as defaultVuetifyOptions } from '../ilt-default/vuetifyOptions';
import { fa } from 'vuetify/iconsets/fa-svg';
import { VuetifyOptions } from 'vuetify';
import { light } from './themes/light';
import { baseDark } from './themes/base';
import { biology, biologyDark } from './themes/biology';
import { chemistry, chemistryDark } from './themes/chemistry';
import { childrenAndRecreation, childrenAndRecreationDark } from './themes/childrenAndRecreation';
import { crafts, craftsDark } from './themes/crafts';
import { english, englishDark } from './themes/english';
import { geography, geographyDark } from './themes/geography';
import { healthAndSocialCare, healthAndSocialCareDark } from './themes/healthAndSocialCare';
import { history, historyDark } from './themes/history';
import { homeAndConsumerStudies, homeAndConsumerStudiesDark } from './themes/homeAndConsumerStudies';
import { marketLanguage, marketLanguageDark } from './themes/marketLanguage';
import { mathematics, mathematicsDark } from './themes/mathematics';
import { nativeLanguage, nativeLanguageDark } from './themes/nativeLanguage';
import { physicalEducation, physicalEducationDark } from './themes/physicalEducation';
import { physics, physicsDark } from './themes/physics';
import { religion, religionDark } from './themes/religion';
import { school, schoolDark } from './themes/school';
import { technology, technologyDark } from './themes/technology';
import { vehiclesAndTransport, vehiclesAndTransportDark } from './themes/vehiclesAndTransport';
import { civics, civicsDark } from './themes/civics';

export const vuetifyOptions: VuetifyOptions = {
  ...defaultVuetifyOptions,
  defaults: {
    ...defaultVuetifyOptions.defaults,
    VTextField: {
      ...defaultVuetifyOptions.defaults.VTextField,
      variant: 'outlined',
      rounded: 'lg',
      VField: {
        class: 'bg-surface-container-lowest',
      },
    },
    VSelect: {
      ...defaultVuetifyOptions.defaults.VSelect,
      variant: 'outlined',
      listProps: {
        bgColor: `rgb(var(--v-theme-surface))`,
      },
      VTextField: {
        VField: {
          style: 'background-color: rgb(var(--v-theme-surface-container-lowest)) !important',
        },
      },
    },
  },
  theme: {
    defaultTheme: 'light',
    variations: {
      colors: [
        'green',
        'teal',
        'blue',
        'gray',
        'pink',
        'yellow',
        'purple',
        'darkblue',
        'orange',
        'gold',
        'highlighterred',
        'hkk',
        'ft',
        'sl',
        'black',
      ],
      lighten: 5,
      darken: 5,
    },
    themes: {
      light,
      baseDark,
      biology,
      biologyDark,
      chemistry,
      chemistryDark,
      childrenAndRecreation,
      childrenAndRecreationDark,
      civics,
      civicsDark,
      crafts,
      craftsDark,
      english,
      englishDark,
      geography,
      geographyDark,
      healthAndSocialCare,
      healthAndSocialCareDark,
      history,
      historyDark,
      homeAndConsumerStudies,
      homeAndConsumerStudiesDark,
      marketLanguage,
      marketLanguageDark,
      mathematics,
      mathematicsDark,
      nativeLanguage,
      nativeLanguageDark,
      physicalEducation,
      physicalEducationDark,
      physics,
      physicsDark,
      religion,
      religionDark,
      school,
      schoolDark,
      technology,
      technologyDark,
      vehiclesAndTransport,
      vehiclesAndTransportDark,
    },
  },
  icons: {
    ...defaultVuetifyOptions.icons,
    sets: {
      ...defaultVuetifyOptions.icons?.sets,
      fa,
    },
  },
};
